import React, { useState } from "react";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";
import _ from "lodash";

import Link from "../util/link";
import Margin from "../basic/layouts/Margin";
import Text from "../basic/Text";
import HubspotForm from "../PardotForm/HubspotForm";
import Event from "../util/GAEvent";
import theme from "../../styles/theme";
import constants from "../../constants";
import socialLinks, { podcastLinks } from "./socialLinks";

const {
	font,
	colors,
	breakPoints: { screenQuery, mobileFirstScreenQuery },
} = theme;

let accents = theme.accents;
accents = accents.concat(accents);

const Footer = styled.div`
	background-color: ${colors.grayscale.main};
	color: ${colors.grayscale.white};
	padding: 75px 0 0 0;
`;

const MenuGroup = styled.div``;
const Grid = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	> * {
		width: calc(25% - 30px);
	}
	${screenQuery.medium} {
		> * {
			width: calc(50% - 20px);
		}
	}
	${screenQuery.small} {
		> * {
			width: 80%;
			margin: auto;
		}
	}
`;
const MenuCell = styled.div`
	/* width: 100%; */
`;

const MenuItems = styled.div`
	margin-bottom: 30px;
`;
const MenuItem = styled(Link)`
	break-inside: avoid;
	display: block;
	width: auto;
	color: ${colors.grayscale.white};
	:hover {
		color: ${colors.brand.main} !important;
	}
	transition-duration: ${theme.transitionDuration};
	padding-bottom: 16px;
	font-size: 16px;
	line-height: 24px;
	letter-spacing: 0.01em;
`;
const MenuItemTitle = styled(Text)`
	a {
		color: #fff;
	}
`;
const TopBar = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 48px;
	flex-direction: column;

	.footer-menu__tagline {
		color: ${colors.white};
		font-family: ${font.recoletaMedium};
		font-size: 36px;
		line-height: 48px;
		letter-spacing: 0.01em;
	}

	${mobileFirstScreenQuery.large} {
		flex-direction: row;
	}

	.brand {
		max-width: 600px;
		margin-bottom: 25px;

		img {
			max-width: 50%;
		}

		h2,
		h3 {
			color: ${colors.white};
			font-weight: 500;
			font-size: 36px;
			line-height: 48px;
			letter-spacing: 0.01em;
		}

		.brand-logo {
			display: flex;
			flex-direction: row;
			align-items: center;
			margin-bottom: 16.5px;
		}

		.brand-info {
			border-left: 1.5px solid #606368;
			padding: 11px 0 11px 16px;
			margin-left: 17px;

			span {
				font-size: 14px;
				text-transform: uppercase;
				color: ${colors.white};
				font-weight: 700;
				font-size: 10.5px;
				line-height: 10px;
				letter-spacing: 2.15px;
			}
		}

		${mobileFirstScreenQuery.large} {
			margin-bottom: 0px;
		}
	}
	.form-wrapper {
		max-width: 427px;

		.form-headline {
			text-align: right;
			margin-bottom: 16px;
		}
	}
`;
const FormWrapper = styled.div`
	position: relative;
	width: 50%;
	.form-headline {
		text-align: center;
	}
	${screenQuery.small} {
		min-width: 80%;
		max-width: 80vw;
		margin: 0 auto;
		flex-wrap: wrap;
		> *,
		.form-headline {
			min-width: 100%;
			text-align: center;
		}
		.form-headline {
			margin-bottom: 15px;
		}
	}
	.full-width {
		width: 100% !important;
		text-align: right;
		${screenQuery.medium} {
			text-align: center;
		}
	}
`;

const BottomBar = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	border-top: 1px solid #ffffff;
	padding: 47px 0 59px 0;

	${mobileFirstScreenQuery.large} {
		flex-direction: row;
	}

	a {
		filter: brightness(0) invert(1);
		transition: all ${theme.transitionDuration};

		&:hover {
			filter: none;
			transition: all ${theme.transitionDuration};
		}
	}
`;

const SocialLinks = styled.div`
	margin-bottom: 25px;

	${mobileFirstScreenQuery.large} {
		margin-bottom: 0px;
	}

	a {
		margin-right: 23px;

		&:last-of-type {
			margin-right: 0px;
		}
	}
`;

const PodcastLinks = styled.div`
	display: flex;
	flex-direction: column;
	gap: 25px;
	align-items: center;

	${mobileFirstScreenQuery.large} {
		flex-direction: row;
	}

	span {
		font-weight: 700;
		font-size: 12px;
		line-height: 12px;
		letter-spacing: 0.2em;
		text-transform: uppercase;
		margin-right: 0px;
		font-family: ${theme.font.regular};

		${mobileFirstScreenQuery.large} {
			margin-right: 16px;
		}
	}
	a {
		margin-right: 24px;

		&:last-of-type {
			margin-right: 0;
		}
	}
`;

const FormComponent = React.memo(() => {
	const location = typeof window === "object" ? window.location : null;
	const [submitted, setSubmitted] = useState(false);

	return (
		<FormWrapper className="form-wrapper">
			{submitted ? (
				<Text className="full-width" textAlign="center" component="b5" color="white">
					Thank you for signing up for our newsletter!
				</Text>
			) : location?.pathname === "/newsletter/" || location?.pathname === "/newsletter" ? null : (
				<>
					<Text className="form-headline" component="b5" color="white">
						Sign up for the Submittable&nbsp;newsletter
					</Text>
					<HubspotForm
						formId="7a866e11-1c56-46f2-9619-9d19158b1196"
						setFormSubmittedState={setSubmitted}
						id="footerForm"
					/>
				</>
			)}
		</FormWrapper>
	);
});

const Menu = ({ menu, index, className, ...props }) => (
	<MenuGroup {...props}>
		<MenuItemTitle
			component="b5"
			color="white"
			css={{
				marginBottom: 16,
				fontSize: "14px",
				lineHeight: "14px",
				letterSpacing: "0.2em",
			}}
		>
			{menu.menuTitleToDisplay.toUpperCase()}
		</MenuItemTitle>
		<MenuItems className="menu-items">
			{menu?.menuItems?.map((item, index) => {
				//let's make this easy. It's gonna either be a menu item or solutions page
				const linkText = item.linkMainText || item.solutionsMasterListLinkText;
				const slug =
					item.linkUrl ||
					`${
						item.prependSlug
							? item.prependSlug === "None"
								? `/${item.slug}`
								: `${item.prependSlug}${item.slug}`
							: `/solutions/${item.slug}`
					}`;

				return (
					<Event key={`footer-link-${slug}`} action="Clicked a footer link" label={linkText}>
						<MenuItem to={slug} key={`${index}-${linkText}`} title={linkText}>
							{linkText}
						</MenuItem>
					</Event>
				);
			})}
		</MenuItems>
	</MenuGroup>
);

export default ({ className }) => {
	const data = useStaticQuery(
		graphql`
			query footerQuery {
				footerMenu: contentfulMenu(contentful_id: { eq: "5UJsfR0RNf3dS0GKt2KGQo" }) {
					menuTitle
					menuItems {
						... on ContentfulMenu {
							menuTitleToDisplay
							menuItems {
								... on ContentfulMenuItem {
									...MenuItemFragment
								}
								... on ContentfulSolutionsPage {
									...SolutionsPageMenuFragment
								}
							}
						}
					}
				}
			}
		`
	);

	const menus = data.footerMenu.menuItems;

	return (
		<Footer className={className}>
			<Margin className={'footer__inner-wrapper'}>
				<TopBar>
					<div className="brand">
						<Link className="brand-logo" to="/">
							<img alt="Submittable Logo" src="/images/footer/submittable-logo-footerv2.svg" />
							<div className="brand-info">
								<span>A Public Benefit Corporation</span>
							</div>
						</Link>
						<Text component="b5" className="footer-menu__tagline">The social impact platform accelerating mission-driven work</Text>
					</div>
					<FormComponent />
				</TopBar>

				<Grid cellsAreHeightOfContent>
					{menus.map((menu, index) => (
						<MenuCell key={menu.menuTitleToDisplay} span={3} spanMd={6} inlineMd>
							<Menu menu={menu} index={index} />
						</MenuCell>
					))}
				</Grid>

				<BottomBar>
					<SocialLinks>
						{socialLinks.map((link, index) => (
							<Link to={link.linkAddress} key={`social-link-${index}`} title={link.linkTitle}>
								<img src={link.logo} alt={link.linkTitle} />
							</Link>
						))}
					</SocialLinks>
					<PodcastLinks>
						<span>Listen to our podcast impact audio</span>
						<div className="inner-links">
							{podcastLinks.map((link, index) => (
								<Link to={link.linkAddress} key={`podcast-link-${index}`} title={link.linkTitle}>
									<img src={link.logo} alt={link.linkTitle} />
								</Link>
							))}
						</div>
					</PodcastLinks>
				</BottomBar>
			</Margin>
		</Footer>
	);
};
